import { PlanetType, StarSystem } from '../types';

export type PlanetTypeDefaults = {
  maxPopulation: number;
  creditsPerPop: number; // base credits per 1.0 pop per tick
  influencePerPop: number; // base influence per 1.0 pop per tick
};

// Single place to tweak planet defaults by type
export const PLANET_TYPE_DEFAULTS: Record<PlanetType, PlanetTypeDefaults> = {
  [PlanetType.Terran]: { maxPopulation: 18, creditsPerPop: 0.5, influencePerPop: 0.2 },
  [PlanetType.Desert]: { maxPopulation: 12, creditsPerPop: 0.8, influencePerPop: 0.1 },
  [PlanetType.Ice]: { maxPopulation: 10, creditsPerPop: 0.3, influencePerPop: 0.3 },
  [PlanetType.Volcanic]: { maxPopulation: 8, creditsPerPop: 1.0, influencePerPop: 0.05 },
  [PlanetType.GasGiant]: { maxPopulation: 6, creditsPerPop: 0.4, influencePerPop: 0.1 },
};

export type PlanetOverride = {
  creditsBonusPct?: number; // e.g. +20 means +20%
  influenceBonusPct?: number; // e.g. +10 means +10%
  maxPopulationOverride?: number; // override the server-reported max pop (display-only)
  notes?: string;
};

// Easy-to-edit per-planet overrides keyed by system name (case-insensitive)
export const PLANET_OVERRIDES_BY_NAME: Record<string, PlanetOverride> = {
  // Examples (edit freely):
  // 'Imperial Bastion Alpha': { creditsBonusPct: 15, influenceBonusPct: 10, notes: 'Core treasury world' },
  // 'Sector Iota': { creditsBonusPct: 10 },
  // 'Neutral Sector': { influenceBonusPct: 10 },
};

export function getPlanetTypeDefaults(planetType: PlanetType): PlanetTypeDefaults {
  return PLANET_TYPE_DEFAULTS[planetType];
}

export function getPlanetOverrideBySystem(system: StarSystem): PlanetOverride | undefined {
  if (!system?.name) return undefined;
  const key = system.name.toLowerCase();
  // Exact name match preferred
  for (const k of Object.keys(PLANET_OVERRIDES_BY_NAME)) {
    if (k.toLowerCase() === key) return PLANET_OVERRIDES_BY_NAME[k];
  }
  return undefined;
}

export function planetTypeLabel(pt: PlanetType): string {
  return String(pt).replace('_', ' ');
}


